<template>
  <b-form-group :id="formGroupId" :label="label" label-class="label-bold">
    <div class="pap-form__text pap-form__text--field-desc">
      <p>
        When published in a book or calendar, your dog image will have a text
        caption at the bottom of the image.
      </p>
      <p>
        The caption gives your dog's name, your name, and your location. (Note:
        In some books the caption will include the breed too.)
      </p>
      <p>
        You can choose how your Last Name appears in the caption: FULL last
        name, or FIRST INITIAL.
      </p>
    </div>
    <!-- <p class="form-text text-dark px-2">
      When published in a book or calendar, your dog image will have a text
      caption at the bottom of the image.
    </p>
    <p class="form-text text-dark px-2">
      The caption gives your dog's name, your name, and your location. (Note: In
      some books the caption will include the breed too.)
    </p>
    <p class="form-text text-dark px-2">
      You can choose how your Last Name appears in the caption: FULL last name,
      or FIRST INITIAL.
    </p> -->

    <div class="form-text text-center">
      <b-form-checkbox
        id="checkbox-use-full-lname"
        v-model="form.captionLastName.value"
        name="checkbox-caption-last-name"
        value="full"
        unchecked-value="initial"
      >
        <!-- Use my FULL last name in the caption -->
        <p class="pap-form__text m-0">Use my FULL last name in the caption</p>
      </b-form-checkbox>
    </div>

    <!-- <p class="form-text text-dark mt-3 px-2">
      The caption for THIS image will be:
    </p> -->
    <p class="pap-form__text text-center mt-3">
      The caption for THIS image will be:
    </p>
    <!-- <p class="form-text text-center text-submit px-2 font-weight-bold">
      {{ captionDisplayHere }}
      <span class="upload__caption-country">{{ form.country.value }}</span>
    </p> -->
    <p class="pap-form__text text-center text-submit font-weight-bold">
      {{ captionDisplayHere }}
      <span class="upload__caption-country">{{ form.country.value }}</span>
    </p>
  </b-form-group>
</template>

<script>
function isEmpty(val) {
  if (val === '' || val === undefined || val === null) {
    return true;
  }
  return false;
}
export default {
  name: 'CaptionSection',
  props: ['id', 'label', 'form'], // form: form data obj, exactly like that in parent component: form: { fieldName: {value:xx, valid:xx, errorMsg:xx }}
  watch: {
    caption: function (captionValue) {
      this.$emit('caption-last-name-toggle', captionValue);
    },
  },
  computed: {
    formGroupId: function () {
      return this.id + '-group';
    },

    captionPipeSym: function () {
      var { dogName, fName } = this.form;
      return dogName.value !== '' && fName.value !== '' ? '|' : '';
    },
    captionLastName: function () {
      var { lName, captionLastName } = this.form;
      var lNameInitial = lName.value.substring(0, 1);
      return captionLastName.value === 'full'
        ? lName.value
        : lNameInitial !== ''
        ? lNameInitial + '.'
        : '';
    },
    captionState: function () {
      var { state, country } = this.form;
      return country.value === 'US' ? state.value : this.captionProvince;
    },
    captionProvince: function () {
      return this.form.province.value === 'none'
        ? ''
        : this.form.province.value;
    },
    captionLastNameLocation_countryUS: function () {
      var { city } = this.form;
      var data = [this.captionLastName, city.value, this.captionState];
      var joinChar = ' ';
      if (
        !isEmpty(this.captionLastName) &&
        !isEmpty(city.value) &&
        !isEmpty(this.captionState)
      ) {
        joinChar = ', ';
      }
      return data.join(joinChar);
    },
    captionLastNameLocation_countryNotUS: function () {
      var { city } = this.form;
      var data = [this.captionLastName, city.value];
      var joinChar = ' ';
      if (!isEmpty(this.captionLastName) && !isEmpty(city.value)) {
        joinChar = ', ';
      }
      if (!isEmpty(this.captionProvince)) {
        data.push(this.captionProvince);
      }
      return data.join(joinChar);
    },

    captionLastNameLocation: function () {
      var { country } = this.form;
      if (country.value === 'US') {
        return this.captionLastNameLocation_countryUS;
      }
      if (country.value !== 'US') {
        // *** AND what about when country is '' or '-' ???
        if (isEmpty(country.value) || country.value === '-') {
          return '';
        }
        return this.captionLastNameLocation_countryNotUS;
      }
      return '';
    },

    // Compute caption for display here on THIS page
    captionDisplayHere: function () {
      var { dogName, fName } = this.form;
      return `${dogName.value} ${this.captionPipeSym} ${fName.value} ${this.captionLastNameLocation}`.trim();
    },
    caption: function () {
      return this.captionDisplayHere + ' ' + this.form.country.value;
    },
  },
};
</script>

<style>
.upload__caption-country {
  display: inline-block;
  margin-left: 0.2rem;
}
</style>